import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
  Modal,
  Dimmer,
  Loader,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import NewLine from "../components/NewLine"
import LineInner from "../components/LineInner"
import { apiGet } from "../utils/apiConnector"
import { storeListApi, productListApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"
import ReactExport from "react-export-excel"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const LinesPage = (props) => {
  const { t } = useTranslation()
  const [modal, setModal] = useState(false)
  const [adding, setAdding] = useState(false)
  const [line, setLine] = useState(null)
  const [lines, setLines] = useState([])
  const [searchValue, setSearchValue] = useState("")
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const renderModal = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={() => {
            setModal(false)
            setAdding(false)
          }}
          style={{ height: "max-content", marginTop: "-40vh" }}
        >
          {adding ? (
            <NewLine getLines={getLines} />
          ) : (
            <LineInner
              line={line}
              getLines={getLines}
              setModal={setModal}
              products={products}
            />
          )}
        </Modal>
      </>
    )
  }
  const getLine = (q) => {
    setLine(q)
    setModal(true)
  }
  const getLines = () => {
    setIsLoading(true)
    apiGet(storeListApi, {})
      .onOk((res) => {
        console.log(res.data.response)
        setLines(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getProducts = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      apiGet(productListApi + "/" + storeId, {})
        .onOk((res) => {
          console.log(res.data.response)
          setProducts(res.data.response)
        })
        .onFail(() => {})
        .afterAll(() => {})
        .startSingle()
    }
  }
  useEffect(() => {
    getProducts()
    getLines()
    return () => {}
  }, [])
  return (
    <>
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
      {renderModal()}
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ fontSize: 32, fontWeight: 500 }}>{t("Lines")}</div>
            <div style={{ marginLeft: 20 }}>
              <Input
                icon="search"
                placeholder={t("Search by name")}
                iconPosition="right"
                style={{ width: 250, height: 35 }}
                value={searchValue}
                onChange={(e, d) => {
                  setSearchValue(d.value)
                }}
              />
            </div>
          </div>
          <div>
            <Button
              positive
              content={t("Add")}
              onClick={() => {
                setAdding(true)
                setModal(true)
              }}
            />
          </div>
        </div>
        <div style={{ display: "none" }}>
          <ExcelFile
            filename={t("Lines")}
            element={
              <Button
                content={t("Export to excel")}
                style={{ marginTop: 10, marginBottom: 10 }}
                color="yellow"
              />
            }
          >
            <ExcelSheet data={lines} name={t("Lines")}>
              {["name", "id", "productName"].map((el) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <ExcelColumn label={t(el)} value={el} />
                )
              })}
            </ExcelSheet>
          </ExcelFile>
        </div>
        <div style={{ marginTop: 40, overflowX: "scroll" }}>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <b>{t("Name")}</b>
                </Table.HeaderCell>
                {/*
                  <Table.HeaderCell>
                    <b>Идентификатор</b>
                  </Table.HeaderCell>
                */}
                <Table.HeaderCell>
                  <b>ID</b>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <b>{t("Product name")}</b>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {lines
                .filter((q) =>
                  q.name.toLowerCase().includes(searchValue.toLowerCase()),
                )
                .map((q) => (
                  <>
                    <Table.Row
                      onClick={() => {
                        getLine(q)
                      }}
                    >
                      <Table.Cell>{q.name}</Table.Cell>
                      {
                        //<Table.Cell>{q.ident}</Table.Cell>
                      }
                      <Table.Cell>{q.id}</Table.Cell>
                      <Table.Cell>{q.productName}</Table.Cell>
                    </Table.Row>
                  </>
                ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </>
  )
}

export default LinesPage
